import { useState } from "react";

export const useTabNavigation = () => {
  const [showVersions, setShowVersions] = useState(true);

  return { showVersions, setShowVersions };
};
